import { checkEnrichedName } from 'bto-models/utils/string';

/**
 * Model for Match Odds
 */
export default class MatchesOddsModel {
  /**
   * class constructor method
   * @param data
   */
  constructor(data, homeTeam = "", guestTeam = "") {
    /**
     * Odds ID
     * @type {number}
     */
    this.marketId = data.id;
    /**
     * Odds Name (Market Name?)
     * @type {string}
     */
    this.marketName = data.n;
    /**
     * Enriched Market Name
     * @type {string}
     */
    this.enrichedMarketName = checkEnrichedName(data.emn, homeTeam, guestTeam, data.sbv);
    /**
     * If this odd is combination with other odds
     * Single = 1, can be played only single
     * Unique = 2, can be played as a single at least
     * Trebles = 3, can be played in a combination with at least three other
     * Quadruple = 4, can be played in a combination with at least four other
     * Quintuple = 5 can be played in a combination with at least five
     * @type {number}
     */
    this.isCombo = data.c;
    /**
     * Outcomes array
     * @type {array}
     */
    this.outcomes = [];
    /**
     * Special bet value
     * @type {null}
     */
    this.specialBetValue = typeof data.sbv !== "undefined" ? data.sbv : null;
    /**
     * Flag that indicates if the market has cashout
     * @type {boolean}
     */
    this.cashout = data.ca || false;
  }
}
